export class TeamListDTO {

    id: string;

    name: string;

}
